import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useCurrentStateStore } from 'stores/useCurrentStateStore'

export const useGetAllOrganizations = () => {
  const get = useTypedApiClient({
    path: '/admin/organizations',
    method: 'get',
  })
  const { currentStateId } = useCurrentStateStore()

  return useQuery({
    queryKey: ['/organizations'],
    queryFn: async () => {
      const { data } = await get('', {
        headers: currentStateId
          ? { 'Current-State-Id': currentStateId.toString() }
          : undefined,
      })
      return data
    },
  })
}
